import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";

export const veradigmConnection = async (data) => {
  try {
    const response = await axios.put(`${Config.apiServerUrl}/users/ehr-connection`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
